import React from 'react';
import {Link} from "react-router-dom";

const SidebarHeader = ({onClose, lien, logo}) => {
  return (
    <div className="pro-header">
      <Link to={lien}>
        <img src={logo} alt="brand" />
      </Link>
      {/* End logo */}

      <div className="fix-icon" data-bs-dismiss="offcanvas" aria-label="Close" onClick={onClose}>
        <span className="flaticon-close"></span>
      </div>
      {/* icon close */}
    </div>
  );
};

export default SidebarHeader;
